import React, {Component} from 'react';

import loadingImg from '../../img/loading_spin.svg';

class Loading extends Component {
    
    render(){
        return (
            <div className="loading__overlay">
                <div className="loading__inner">
                    <img className="loading__img" src={loadingImg} alt="Loading ..."/>
                </div>
            </div>
        );
    }
    
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js